import { Navigate } from "react-router-dom"
import { useRole, type Role } from "@/hooks/useRole"

interface RoleGuardProps {
  requiredRole: Role
  children: React.ReactNode
  /**
   * ロール不足時のリダイレクト先（既定 "/"）。管理メニューの出し分けで、
   * member/viewer を弾く先を「AIアシスタント設定」にしたい場合などに使う。
   * （例: /admin の index を admin 限定にしつつ、member は /admin/agent へ着地）
   */
  redirectTo?: string
}

export function RoleGuard({ requiredRole, children, redirectTo = "/" }: RoleGuardProps) {
  const { hasMinimumRole } = useRole()

  if (!hasMinimumRole(requiredRole)) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
